import {getAuthToken} from '../../common/authTokenUtil';
import {useEffect, useState} from "react";
import {targetRedirectApi} from "../../api/TargetRedirectApi"

export  const TargetRedirectComponent = () => {
    const authToken = getAuthToken()
    const [progress, setProgress] = useState(0);

    useEffect(()=> {
        let intervalId: NodeJS.Timeout | null = null;
        let redirected = false;

        if(authToken !== null && authToken !== undefined) {
            targetRedirectApi(sessionStorage.getItem("orgName"),
                sessionStorage.getItem("loginName"),
                authToken
            )
                .then(
                response => {
                    if(response.redirectUrl !== null && !redirected ) {
                        redirected = true;

                      if (response.redirectUrl.includes("card/home")) {
                        const match = response.redirectUrl.match(/\/?card\/([a-zA-Z0-9-_]+)/);
                        if (match?.[1]) {
                          window.location.href = `/card/${match[1]}`;
                        } else {
                          console.error("Blocked unsafe redirect:", response.redirectUrl);
                        }
                      }
                    }
                }
            ).catch(exception => {
                console.error("Error during target redirect:", exception);
                }
            )
        }

        intervalId = setInterval(() => {
            setProgress(prev => (prev < 100 ? prev + 2 : 100));
        }, 70);

        return () => {
            if (intervalId) clearInterval(intervalId);
        };
    },[authToken,targetRedirectApi])

    return null;
};
